module.exports = __webpack_public_path__ + "fonts/Manrope-600-greek15_f91e858.woff2";